// src/pages/pengamatan/buah-alami/hooks/useProcessedDialog.js
import { useState } from 'react';

export const useProcessedDialog = () => {
  const [processedDialogOpen, setProcessedDialogOpen] = useState(false);
  const [draftDialogOpen, setDraftDialogOpen] = useState(false); // TAMBAHKAN STATE UNTUK DRAFT
  const [selectedItemsForProcessing, setSelectedItemsForProcessing] = useState([]);
  const [selectedItemsForDraft, setSelectedItemsForDraft] = useState([]); // TAMBAHKAN STATE UNTUK DRAFT
  const [processingData, setProcessingData] = useState([]);
  const [draftData, setDraftData] = useState([]); // TAMBAHKAN STATE UNTUK DRAFT
  const [currentTab, setCurrentTab] = useState('');
  const [actionType, setActionType] = useState(''); // 'processed' atau 'draft'

  const handleOpenProcessedDialog = (selectedItems, orders, tab) => {
    // Filter data yang dipilih
    const selectedOrders = orders.filter(order => 
      selectedItems.includes(order.id)
    );

    // Siapkan data untuk ditampilkan di dialog - HANYA PLOT YANG AKAN DIUBAH
    const processingData = selectedOrders.flatMap(order => {
      if (!order.allPlots) return [];
      
      // HANYA ambil plot dengan status Approved yang akan diubah ke Processed
      const plotsToProcess = order.allPlots.filter(plot => 
        plot.status_pengamatan === 'Approved'
      );

      // Urutkan plot secara ascending
      const sortedPlots = plotsToProcess.sort((a, b) => {
        const plotA = a.plot || '';
        const plotB = b.plot || '';
        
        if (!isNaN(plotA) && !isNaN(plotB)) {
          return parseInt(plotA) - parseInt(plotB);
        }
        
        return plotA.localeCompare(plotB);
      });

      return sortedPlots.map(plot => ({
        id_pengamatan: order.pengamatanKey,
        lokasi: order.lokasi,
        id_lokasi: order.id_lokasi,
        plot: plot.plot || '-',
        luas_plot: plot.luas_plot || '-',
        pjp: plot.pjp || '-',
        status_sebelumnya: plot.status_pengamatan,
        status_baru: 'Processed',
        orderId: order.id,
        plotKey: plot.plotKey || plot.plot
      }));
    });

    // HAPUS DUPLIKAT - pastikan tidak ada plot yang sama
    const uniqueProcessingData = processingData.filter((plot, index, self) =>
      index === self.findIndex(p => 
        p.id_pengamatan === plot.id_pengamatan && 
        p.plotKey === plot.plotKey
      )
    );

    setProcessingData(uniqueProcessingData);
    setSelectedItemsForProcessing(selectedItems);
    setCurrentTab(tab);
    setActionType('processed');
    setProcessedDialogOpen(true);
  };

  // FUNGSI BARU: Handle buka dialog untuk Draft
  const handleOpenDraftDialog = (selectedItems, orders, tab) => {
    // Filter data yang dipilih
    const selectedOrders = orders.filter(order => 
      selectedItems.includes(order.id)
    );

    // Tentukan plot mana yang akan diubah berdasarkan tab
    const draftData = selectedOrders.flatMap(order => {
      if (!order.allPlots) return [];
      
      let plotsToDraft = [];
      
      // LOGIKA BERBEDA BERDASARKAN TAB
      if (tab === 'Approved') {
        // Di tab Approved: ubah Approved → Draft
        plotsToDraft = order.allPlots.filter(plot => 
          plot.status_pengamatan === 'Approved'
        );
      } else if (tab === 'Processed') {
        // Di tab Processed: ubah Processed → Draft
        plotsToDraft = order.allPlots.filter(plot => 
          plot.status_pengamatan === 'Processed'
        );
      }

      // Urutkan plot secara ascending
      const sortedPlots = plotsToDraft.sort((a, b) => {
        const plotA = a.plot || '';
        const plotB = b.plot || '';
        
        if (!isNaN(plotA) && !isNaN(plotB)) {
          return parseInt(plotA) - parseInt(plotB);
        }
        
        return plotA.localeCompare(plotB);
      });

      return sortedPlots.map(plot => ({
        id_pengamatan: order.pengamatanKey,
        lokasi: order.lokasi,
        id_lokasi: order.id_lokasi,
        plot: plot.plot || '-',
        luas_plot: plot.luas_plot || '-',
        pjp: plot.pjp || '-',
        status_sebelumnya: plot.status_pengamatan,
        status_baru: 'Draft',
        orderId: order.id,
        plotKey: plot.plotKey || plot.plot
      }));
    });

    // HAPUS DUPLIKAT - pastikan tidak ada plot yang sama
    const uniqueDraftData = draftData.filter((plot, index, self) =>
      index === self.findIndex(p => 
        p.id_pengamatan === plot.id_pengamatan && 
        p.plotKey === plot.plotKey
      )
    );

    setDraftData(uniqueDraftData);
    setSelectedItemsForDraft(selectedItems);
    setCurrentTab(tab);
    setActionType('draft');
    setDraftDialogOpen(true);
  };

  const handleCloseProcessedDialog = () => {
    setProcessedDialogOpen(false);
    setProcessingData([]);
    setSelectedItemsForProcessing([]);
    setActionType('');
  };

  // FUNGSI BARU: Handle tutup dialog draft
  const handleCloseDraftDialog = () => {
    setDraftDialogOpen(false);
    setDraftData([]);
    setSelectedItemsForDraft([]);
    setActionType('');
  };

  return {
    processedDialogOpen,
    draftDialogOpen, // TAMBAHKAN RETURN
    processingData,
    draftData, // TAMBAHKAN RETURN
    selectedItemsForProcessing,
    selectedItemsForDraft, // TAMBAHKAN RETURN
    currentTab,
    actionType, // TAMBAHKAN RETURN
    handleOpenProcessedDialog,
    handleOpenDraftDialog, // TAMBAHKAN RETURN
    handleCloseProcessedDialog,
    handleCloseDraftDialog // TAMBAHKAN RETURN
  };
};